import { types } from "../types/types";

const initialState = {
  notifications: [],
};
export const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.saveNotification:
      return {
        ...state,
        notifications: [...state.notifications, action.payload],
      };

    default:
      return state;
  }
};
